"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
function HoverComponent(props) {
    var _a = React.useState(false), isHovered = _a[0], setHover = _a[1];
    var onMouseEnter = function () { return setHover(true); };
    var onMouseLeave = function () { return setHover(false); };
    return (React.createElement("div", { onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, title: props.altText }, isHovered ? props.hoverElement : props.normalElement));
}
exports.HoverComponent = HoverComponent;
//# sourceMappingURL=HoverComponent.js.map